import React from 'react';
import PropTypes from 'prop-types';

import { SpaceRoleManagementScreen } from '@confluence/space-roles/entry-points/SpaceRoleManagementScreen';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';
import type { Match } from '@confluence/route-manager';

export const SpaceMembersRoute = ({ name, params: { spaceKey } }: Match) => (
	<Screen
		screenEvent={{
			name: 'spaceMembersScreen',
			id: spaceKey,
		}}
		pageState={{
			routeName: name,
			spaceKey,
		}}
	>
		<MainLayout spaceKey={spaceKey} navView={CONTAINER_HOME_ID}>
			<SpaceRoleManagementScreen spaceKey={spaceKey} />
		</MainLayout>
	</Screen>
);

SpaceMembersRoute.propTypes = {
	name: PropTypes.string.isRequired,
	params: PropTypes.shape({
		spaceKey: PropTypes.string.isRequired,
	}).isRequired,
};
